class ProductTabMedia extends HTMLElement {
  constructor() {
    super()
    this.lightbox = null
    this.currentIndex = 0
    this.isMuted = true
  }

  connectedCallback() {
    this.initLightbox()
  }

  initLightbox() {
    this.items = this.querySelectorAll('.product-tab-media__item')
    
    this.items.forEach((item, index) => {
      item.style.cursor = 'pointer'
      item.addEventListener('click', () => this.openLightbox(index))
    })
  }

  openLightbox(index) {
    this.currentIndex = index
    this.createLightbox()
    this.showMedia(index)
  }

  createLightbox() {
    if (this.lightbox) return

    this.lightbox = document.createElement('div')
    this.lightbox.className = 'pswp pswp--supports-fs pswp--notouch pswp--css_animation pswp--svg pswp--zoom-allowed'
    this.lightbox.setAttribute('tabindex', '-1')
    this.lightbox.setAttribute('role', 'dialog')
    this.lightbox.setAttribute('aria-hidden', 'false')
    this.lightbox.style.cssText = `
      position: fixed;
      opacity: 0;
      transition: opacity 0.4s ease;
    `
    
    this.lightbox.innerHTML = `
      <div class="pswp__bg" style="opacity: 0; background: rgba(0, 0, 0, 0.85); transition: opacity 0.4s ease;"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__top-bar">
          <button class="pswp__button pswp__button--close-top" title="Close (esc)" style="opacity: 0; transition: opacity 0.4s ease;">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.23125 8.33445L5.98348 8.3011C5.97655 8.35263 5.9866 8.39445 5.99117 8.41158C5.99693 8.43317 6.00434 8.45182 6.01027 8.46541C6.02223 8.49279 6.03722 8.51989 6.05118 8.54338C6.07977 8.59146 6.1173 8.6464 6.15599 8.69941C6.2313 8.80259 6.32916 8.92321 6.40174 8.99255L6.40216 8.99295C7.40633 9.94777 7.59408 10.1189 7.85309 10.3549C8.07374 10.5559 8.3461 10.8041 9.21896 11.6241C9.76059 12.1346 10.3006 12.6322 10.838 13.1274C11.9287 14.1324 13.0086 15.1274 14.0695 16.2004L14.0693 16.2006L14.0777 16.2084C14.4583 16.5596 14.7323 16.8095 14.9483 17.0064C15.6464 17.6429 15.7388 17.7272 16.8629 18.895C17.0636 19.1045 17.2588 19.3107 17.4514 19.5141C18.1577 20.2603 18.8277 20.9681 19.5972 21.6561L19.5991 21.6577C20.2192 22.2012 20.7458 22.7441 21.2715 23.2861C21.5008 23.5224 21.7299 23.7586 21.9665 23.9947L21.9681 23.9962C22.213 24.2361 22.4354 24.47 22.6576 24.7048C22.6735 24.7215 22.6893 24.7383 22.7052 24.755C22.9106 24.9722 23.1174 25.1908 23.339 25.4115C23.7858 25.8673 24.2982 26.3285 24.6795 26.6718L24.6885 26.6798L24.6951 26.6858L24.7022 26.6913C24.7624 26.7382 24.8402 26.8028 24.9287 26.8763C25.1353 27.048 25.4005 27.2683 25.6386 27.4263C25.8083 27.5389 26.0021 27.6473 26.1842 27.6807C26.2789 27.6981 26.3934 27.6996 26.5036 27.6481C26.6069 27.5999 26.679 27.5182 26.7241 27.422C26.7814 27.3474 26.8272 27.293 26.8646 27.2496C26.8729 27.24 26.8813 27.2303 26.8899 27.2205C26.9202 27.1857 26.9514 27.1498 26.976 27.1174C27.0623 27.0032 27.0912 26.9008 27.1137 26.7423L27.1279 26.6422L27.0686 26.5604C26.9116 26.3439 26.716 26.1227 26.4839 25.8966C25.9585 25.3606 25.416 24.8331 24.8668 24.299C24.7913 24.2256 24.7156 24.152 24.6398 24.0782C24.0116 23.4667 23.3753 22.843 22.7404 22.1795L22.7404 22.1794C21.9023 21.3041 21.0043 20.4406 20.1225 19.5927C20.0454 19.5186 19.9685 19.4446 19.8917 19.3707C18.9347 18.4499 18.005 17.5482 17.1899 16.6615L17.1899 16.6614C16.4013 15.8042 16.268 15.677 15.9938 15.4152C15.8833 15.3096 15.7498 15.1822 15.5413 14.9763L15.5414 14.9762L15.5371 14.9722C15.476 14.9146 15.4144 14.8569 15.3521 14.7986C15.0539 14.5195 14.741 14.2267 14.4078 13.8721L14.4012 13.8651L14.3941 13.8586L11.3656 11.0964L10.8816 10.655L10.8844 10.6829C10.7501 10.5549 10.6188 10.4208 10.4847 10.2811C10.4357 10.23 10.3862 10.178 10.336 10.1254C10.0997 9.87749 9.84877 9.61423 9.56198 9.35125L9.56129 9.35063C9.36135 9.16865 9.20526 9.03072 9.06441 8.90626C8.78663 8.66081 8.56815 8.46775 8.18954 8.09246L8.18945 8.09238C8.11667 8.0203 8.03079 7.92439 7.9314 7.8134C7.89866 7.77683 7.86445 7.73863 7.82876 7.6991C7.69015 7.54559 7.53338 7.37706 7.3788 7.24219L7.36686 7.23178L7.3537 7.22295C7.16012 7.09311 6.95258 7.10643 6.78129 7.18427C6.6222 7.25656 6.48704 7.38539 6.38206 7.51253C6.27432 7.64301 6.18283 7.79071 6.11552 7.9248C6.05151 8.05232 5.99703 8.19188 5.98315 8.30365L6.23125 8.33445ZM6.23125 8.33445C6.22431 8.38601 6.4616 8.70399 6.57443 8.81178L7.21445 7.43058C6.78565 7.14298 6.26534 8.05991 6.23125 8.33445Z" fill="white" stroke="white" stroke-width="0.5"></path>
              <path d="M7.57176 28.0061L7.53841 28.2538C7.58994 28.2608 7.63176 28.2507 7.64889 28.2461C7.67048 28.2404 7.68912 28.233 7.70271 28.227C7.7301 28.2151 7.75719 28.2001 7.78068 28.1861C7.82877 28.1575 7.8837 28.12 7.93672 28.0813C8.0399 28.006 8.16051 27.9081 8.22985 27.8356L8.23025 27.8351C9.18508 26.831 9.35616 26.6432 9.59218 26.3842C9.79325 26.1636 10.0414 25.8912 10.8614 25.0183C11.3719 24.4767 11.8695 23.9367 12.3647 23.3993C13.3697 22.3086 14.3648 21.2287 15.4377 20.1679L15.4379 20.168L15.4457 20.1596C15.7969 19.779 16.0468 19.505 16.2437 19.289C16.8802 18.5909 16.9645 18.4985 18.1323 17.3744C18.3418 17.1737 18.548 16.9785 18.7514 16.7859C19.4976 16.0796 20.2054 15.4096 20.8934 14.6401L20.895 14.6382C21.4385 14.0181 21.9814 13.4915 22.5234 12.9658C22.7597 12.7365 22.9959 12.5074 23.232 12.2708L23.2335 12.2692C23.4734 12.0243 23.7073 11.8019 23.9421 11.5797C23.9588 11.5638 23.9756 11.548 23.9924 11.5321C24.2095 11.3267 24.4281 11.1199 24.6488 10.8983C25.1046 10.4515 25.5658 9.93908 25.9091 9.55776L25.9171 9.54877L25.9231 9.54216L25.9286 9.53514C25.9755 9.4749 26.0401 9.39714 26.1136 9.30862C26.2853 9.10202 26.5056 8.83677 26.6636 8.59871C26.7762 8.42903 26.8846 8.23516 26.918 8.05312C26.9354 7.95842 26.9369 7.84394 26.8854 7.73371C26.8372 7.63045 26.7555 7.55835 26.6593 7.51323C26.5847 7.4559 26.5303 7.41012 26.4869 7.37267C26.4773 7.36444 26.4676 7.35597 26.4578 7.34743C26.423 7.3171 26.3872 7.28588 26.3547 7.26134C26.2405 7.17497 26.1381 7.14606 25.9796 7.12357L25.8795 7.10936L25.7977 7.1687C25.5812 7.32568 25.36 7.52128 25.1339 7.75345C24.5979 8.27883 24.0704 8.82128 23.5363 9.37046C23.4629 9.44601 23.3893 9.52169 23.3155 9.59747C22.704 10.2257 22.0803 10.862 21.4168 11.4969L21.4168 11.4969C20.5414 12.335 19.6779 13.233 18.83 14.1148C18.7559 14.1919 18.6819 14.2688 18.608 14.3456C17.6872 15.3026 16.7855 16.2323 15.8988 17.0474L15.8987 17.0475C15.0415 17.836 14.9143 17.9693 14.6525 18.2435C14.5469 18.354 14.4195 18.4875 14.2136 18.696L14.2135 18.6959L14.2095 18.7002C14.1519 18.7613 14.0942 18.8229 14.036 18.8852C13.7568 19.1834 13.464 19.4963 13.1094 19.8295L13.1024 19.8361L13.0959 19.8432L10.3337 22.8717L9.89226 23.3557L9.92016 23.3529C9.79216 23.4872 9.65807 23.6185 9.51836 23.7526C9.46726 23.8016 9.41532 23.8511 9.36268 23.9013C9.1148 24.1376 8.85154 24.3885 8.58856 24.6753L8.58794 24.676C8.40595 24.876 8.26802 25.032 8.14357 25.1729C7.89811 25.4507 7.70505 25.6692 7.32977 26.0478L7.32968 26.0478C7.25761 26.1206 7.16169 26.2065 7.05071 26.3059C7.01414 26.3386 6.97593 26.3729 6.93641 26.4085C6.78289 26.5472 6.61436 26.7039 6.4795 26.8585L6.46908 26.8704L6.46026 26.8836C6.33042 27.0772 6.34374 27.2847 6.42157 27.456C6.49387 27.6151 6.6227 27.7503 6.74984 27.8552C6.88032 27.963 7.02802 28.0545 7.16211 28.1218C7.28963 28.1858 7.42918 28.2403 7.54095 28.2542L7.57176 28.0061ZM7.57176 28.0061C7.62331 28.013 7.94129 27.7757 8.04908 27.6629L6.66788 27.0229C6.38028 27.4517 7.29722 27.972 7.57176 28.0061Z" fill="white" stroke="white" stroke-width="0.5" stroke-linecap="square"></path>
            </svg>
          </button>
          <div class="pswp__mute-controls" style="opacity: 0; transition: opacity 0.4s ease; display: none;">
            <button class="pswp__button pswp__button--unmute active" title="Unmute" style="transition: opacity 0.4s ease;">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.8" cx="20" cy="20" r="20" fill="white"></circle>
                <path d="M24.5 19C24.4377 20.0031 24.6072 27.4023 24.348 28.3093C24.3454 28.3186 23.2323 27.5797 23.0543 27.4685C21.7676 26.6643 18.2628 23.1987 16.983 23.153C16.2107 23.1255 15.4235 23.1112 14.6417 23.1112C14.4978 23.1112 13.355 23.2089 13.355 23.0067C13.355 22.8296 13.3591 22.6519 13.355 22.4748C13.3453 22.0558 13.2933 21.6277 13.2737 21.2067C13.2459 20.6083 13.2464 19.9846 13.1785 19.3904C13.0587 18.3422 12.8406 16.3812 13.1878 16.213C13.6275 16 13.6275 16.213 13.9674 16.213C14.267 16.3066 14.5986 16.245 14.9112 16.2548C15.5198 16.2738 16.1515 16.3965 16.753 16.4824C17.2212 16.5493 17.2394 16.3759 17.5357 16.0876C17.8305 15.8008 18.1757 15.5116 18.5205 15.2909C18.9664 15.0056 19.3752 14.6744 19.8026 14.3642C20.2797 14.0179 20.7997 13.7111 21.2334 13.3074C22.1036 12.4972 23.0725 11.7655 23.9927 11.0126C24.0782 10.9427 24.0915 11.1838 24.0972 11.2402C24.125 11.5179 24.0601 12.3457 24.0978 12.6227C24.2305 13.5983 24.0666 14.0168 24.0978 15" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
                <path d="M12.3633 27.3302C13.2237 26.4698 14.077 25.6165 14.9343 24.7592C16.4783 23.2151 17.7922 21.4983 19.3074 19.927C20.8659 18.3108 22.4114 16.6494 24.1855 15.2555C25.5002 14 27.5002 12 28.5002 11" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
              </svg>
            </button>
            <button class="pswp__button pswp__button--mute" title="Mute" style="transition: opacity 0.4s ease;">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.8" cx="20" cy="20" r="20" fill="white"></circle>
                <path d="M9.17842 19.3904C9.05863 18.3422 8.84049 16.3812 9.18771 16.213C9.62749 16 9.62749 16.213 9.96737 16.213C10.2669 16.3066 10.5985 16.245 10.9111 16.2548C11.5197 16.2738 12.1514 16.3965 12.753 16.4824C13.2211 16.5493 13.2394 16.3759 13.5357 16.0876C13.8304 15.8008 14.1756 15.5116 14.5205 15.2909C14.9663 15.0056 15.3752 14.6744 15.8026 14.3642C16.2797 14.0179 16.7997 13.7111 17.2333 13.3074C18.1035 12.4972 19.0724 11.7655 19.9926 11.0126C20.0781 10.9427 20.0915 11.1838 20.0971 11.2402C20.1249 11.5179 20.06 12.3457 20.0977 12.6227C20.2304 13.5983 19.9614 14.6395 19.9926 15.6227C20.056 17.6196 20.1774 19.215 19.9926 21.2067C19.8753 22.4712 20.1038 23.5808 20.0251 24.8486C19.9629 25.8516 20.6071 27.4023 20.348 28.3093C20.3453 28.3186 19.2322 27.5797 19.0543 27.4685C17.7676 26.6643 14.2628 23.1987 12.9829 23.153C12.2106 23.1255 11.4235 23.1112 10.6417 23.1112C10.4977 23.1112 9.35494 23.2089 9.35494 23.0067C9.35494 22.8296 9.35906 22.6519 9.35494 22.4748C9.3452 22.0558 9.29323 21.6277 9.27365 21.2067C9.24582 20.6083 9.24633 19.9846 9.17842 19.3904Z" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
                <path d="M22.9805 16.4219C23.542 16.9834 24.0102 17.5506 24.2858 18.3032C24.5546 19.0374 24.6946 19.7383 24.6946 20.519C24.6946 21.2417 24.4716 21.8897 24.1418 22.5258C23.9955 22.8079 23.4868 23.3201 23.1477 23.3201" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
                <path d="M26.1543 13.9971C26.4428 14.1734 26.6424 14.5608 26.8232 14.8332C27.1665 15.3504 27.528 15.8686 27.8266 16.4126C28.2471 17.1787 28.5201 17.9358 28.6302 18.8049C28.7758 19.9533 28.8682 21.181 28.7371 22.3353C28.6253 23.3189 28.1078 24.212 27.4828 24.9506C27.2934 25.1745 27.0329 25.5459 26.7814 25.6939C26.6693 25.7598 26.4029 25.9607 26.3633 26.0794" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
              </svg>
            </button>
          </div>
        </div>
        <div class="pswp__container" style="transform: translate3d(0px, 0px, 0px);">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--idle">
          <button class="btn btn--secondary btn--circle pswp__button pswp__button--arrow--left" title="Previous" style="opacity: 0; transition: opacity 0.4s ease;">
            <element-icon>
              <svg xmlns="http://www.w3.org/2000/svg" class="element-icon element-icon-chevron-left element-icon--line" viewBox="0 0 284.49 498.98" fill="currentColor" width="20" height="20">
                <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0"></path>
              </svg>
            </element-icon>
          </button>
          <button class="btn btn--secondary btn--circle btn--large pswp__button pswp__button--play-pause" title="Play/Pause (Space)" style="display: none; opacity: 0; transition: opacity 0.4s ease;">
            <element-icon class="play-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <path d="M20 10 L50 32 L20 54 Z" fill="currentColor"/>
              </svg>
            </element-icon>
            <element-icon class="pause-icon" style="display: none;">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <rect x="18" y="12" width="10" height="40" fill="currentColor"/>
                <rect x="36" y="12" width="10" height="40" fill="currentColor"/>
              </svg>
            </element-icon>
          </button>
          <button class="btn btn--secondary btn--circle pswp__button pswp__button--arrow--right" title="Next" style="opacity: 0; transition: opacity 0.4s ease;">
            <element-icon>
              <svg xmlns="http://www.w3.org/2000/svg" class="element-icon element-icon-chevron-right element-icon--line" viewBox="0 0 284.49 498.98" fill="currentColor" width="20" height="20">
                <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98"></path>
              </svg>
            </element-icon>
          </button>
        </div>
      </div>
    `

    document.body.appendChild(this.lightbox)
    document.body.classList.add('photoswipe-open')
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.lightbox.style.opacity = '1'
        this.lightbox.classList.add('pswp--open', 'pswp--visible', 'pswp--animated-in')
        this.lightbox.querySelector('.pswp__bg').style.opacity = '1'
      })
    })

    this.lightbox.querySelector('.pswp__button--arrow--left').addEventListener('click', () => this.navigate(-1))
    this.lightbox.querySelector('.pswp__button--arrow--right').addEventListener('click', () => this.navigate(1))
    
    const closeTopBtn = this.lightbox.querySelector('.pswp__button--close-top')
    closeTopBtn.addEventListener('click', () => this.closeLightbox())
    
    const muteBtn = this.lightbox.querySelector('.pswp__button--mute')
    const unmuteBtn = this.lightbox.querySelector('.pswp__button--unmute')
    this.muteControls = this.lightbox.querySelector('.pswp__mute-controls')
    
    muteBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      this.toggleMute()
    })
    
    unmuteBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      this.toggleMute()
    })
    
    const bg = this.lightbox.querySelector('.pswp__bg')
    const scrollWrap = this.lightbox.querySelector('.pswp__scroll-wrap')
    
    bg.addEventListener('click', () => this.closeLightbox())
    scrollWrap.addEventListener('click', (e) => {
      if (e.target === scrollWrap) {
        this.closeLightbox()
      }
    })
    
    const container = this.lightbox.querySelector('.pswp__container')
    container.addEventListener('click', (e) => {
      if (e.target === container || e.target.classList.contains('pswp__item') || e.target.classList.contains('pswp__zoom-wrap')) {
        this.closeLightbox()
      }
      
      const video = e.target.closest('video')
      if (video) {
        e.stopPropagation()
        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      }
    })
    
    this.playPauseBtn = this.lightbox.querySelector('.pswp__button--play-pause')
    this.playPauseBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      this.togglePlayPause()
    })
    
    this.keyHandler = (e) => {
      if (!this.lightbox) return
      if (e.key === 'Escape') this.closeLightbox()
      if (e.key === 'ArrowLeft') this.navigate(-1)
      if (e.key === 'ArrowRight') this.navigate(1)
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault()
        this.togglePlayPause()
      }
      if (e.key === 'm' || e.key === 'M') {
        e.preventDefault()
        this.toggleMute()
      }
    }
    document.addEventListener('keydown', this.keyHandler)
    
    this.initAutoHideUI()
  }

  initAutoHideUI() {
    let hideTimeout
    const ui = this.lightbox.querySelector('.pswp__ui')
    const topBar = this.lightbox.querySelector('.pswp__top-bar')
    const buttons = this.lightbox.querySelectorAll('.pswp__button')
    const closeTopBtn = this.lightbox.querySelector('.pswp__button--close-top')
    
    const showUI = () => {
      if (ui) {
        ui.classList.remove('pswp__ui--idle')
        buttons.forEach(btn => {
          if (btn.style.display !== 'none' && !btn.closest('.pswp__top-bar')) {
            btn.style.opacity = '1'
            btn.style.pointerEvents = 'auto'
          }
        })
      }
      if (closeTopBtn) {
        closeTopBtn.style.opacity = '1'
        closeTopBtn.style.pointerEvents = 'auto'
      }
      if (this.muteControls && this.muteControls.style.display !== 'none') {
        this.muteControls.style.opacity = '1'
        this.muteControls.style.pointerEvents = 'auto'
      }
    }
    
    const hideUI = () => {
      if (ui) {
        ui.classList.add('pswp__ui--idle')
        buttons.forEach(btn => {
          if (!btn.closest('.pswp__top-bar')) {
            btn.style.opacity = '0'
            btn.style.pointerEvents = 'none'
          }
        })
      }
      if (closeTopBtn) {
        closeTopBtn.style.opacity = '0'
        closeTopBtn.style.pointerEvents = 'none'
      }
      if (this.muteControls) {
        this.muteControls.style.opacity = '0'
        this.muteControls.style.pointerEvents = 'none'
      }
    }
    
    const resetTimer = () => {
      showUI()
      clearTimeout(hideTimeout)
      hideTimeout = setTimeout(hideUI, 3000)
    }
    
    this.lightbox.addEventListener('mousemove', resetTimer)
    this.lightbox.addEventListener('mouseenter', resetTimer)
    
    resetTimer()
  }

  showMedia(index) {
    const container = this.lightbox.querySelector('.pswp__container')
    const lightboxItems = container.querySelectorAll('.pswp__item')
    
    lightboxItems.forEach(item => {
      item.innerHTML = ''
      item.style.display = 'none'
    })
    
    const item = this.items[index]
    const video = item.querySelector('video')
    const img = item.querySelector('img')
    
    const zoomWrap = document.createElement('div')
    zoomWrap.className = 'pswp__zoom-wrap'
    zoomWrap.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      transform: none;
      opacity: 0;
      transition: opacity 0.4s ease;
    `
    
    if (video) {
      const videoClone = document.createElement('video')
      videoClone.controls = false
      videoClone.autoplay = true
      videoClone.loop = true
      videoClone.muted = this.isMuted
      videoClone.playsInline = true
      videoClone.className = 'pswp__video'
      videoClone.style.cssText = `
        max-width: 90vw;
        max-height: 90vh;
        width: auto;
        height: auto;
        display: block;
        border-radius: 8px;
      `
      
      const source = video.querySelector('source')
      if (source) {
        const sourceClone = document.createElement('source')
        sourceClone.src = source.src
        sourceClone.type = source.type
        videoClone.appendChild(sourceClone)
      }
      
      zoomWrap.appendChild(videoClone)
      this.currentVideo = videoClone
      
      this.playPauseBtn.style.display = 'block'
      if (this.muteControls) {
        this.muteControls.style.display = 'flex'
        this.updateMuteButtons()
      }
      this.updatePlayPauseIcon()
      
      videoClone.addEventListener('play', () => this.updatePlayPauseIcon())
      videoClone.addEventListener('pause', () => this.updatePlayPauseIcon())
    } else if (img) {
      const imgClone = document.createElement('img')
      imgClone.src = img.src
      imgClone.className = 'pswp__img'
      imgClone.style.cssText = `
        max-width: 90vw;
        max-height: 90vh;
        width: auto;
        height: auto;
        display: block;
        border-radius: 8px;
      `
      zoomWrap.appendChild(imgClone)
      this.currentVideo = null
      this.playPauseBtn.style.display = 'none'
      if (this.muteControls) {
        this.muteControls.style.display = 'none'
      }
    }
    
    lightboxItems[1].appendChild(zoomWrap)
    lightboxItems[1].style.display = 'block'
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        zoomWrap.style.opacity = '1'
      })
    })
    
    const leftBtn = this.lightbox.querySelector('.pswp__button--arrow--left')
    const rightBtn = this.lightbox.querySelector('.pswp__button--arrow--right')
    
    if (this.items.length <= 1) {
      leftBtn.style.display = 'none'
      rightBtn.style.display = 'none'
    } else {
      leftBtn.style.display = ''
      rightBtn.style.display = ''
    }
  }

  togglePlayPause() {
    if (!this.currentVideo) return
    
    if (this.currentVideo.paused) {
      this.currentVideo.play()
    } else {
      this.currentVideo.pause()
    }
  }

  updatePlayPauseIcon() {
    if (!this.currentVideo) return
    
    const playIcon = this.playPauseBtn.querySelector('.play-icon')
    const pauseIcon = this.playPauseBtn.querySelector('.pause-icon')
    
    if (this.currentVideo.paused) {
      if (playIcon) playIcon.style.display = 'block'
      if (pauseIcon) pauseIcon.style.display = 'none'
    } else {
      if (playIcon) playIcon.style.display = 'none'
      if (pauseIcon) pauseIcon.style.display = 'block'
    }
  }

  navigate(direction) {
    const zoomWrap = this.lightbox.querySelector('.pswp__zoom-wrap')
    if (zoomWrap) {
      zoomWrap.style.opacity = '0'
    }
    
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + direction + this.items.length) % this.items.length
      this.showMedia(this.currentIndex)
    }, 200)
  }

  closeLightbox() {
    if (!this.lightbox) return
    
    this.lightbox.classList.remove('pswp--visible', 'pswp--animated-in')
    this.lightbox.style.opacity = '0'
    this.lightbox.querySelector('.pswp__bg').style.opacity = '0'
    
    const zoomWrap = this.lightbox.querySelector('.pswp__zoom-wrap')
    if (zoomWrap) {
      zoomWrap.style.opacity = '0'
    }
    
    setTimeout(() => {
      if (this.lightbox && this.lightbox.parentNode) {
        document.body.removeChild(this.lightbox)
        document.body.classList.remove('photoswipe-open')
        this.lightbox = null
      }
    }, 400)

    if (this.keyHandler) {
      document.removeEventListener('keydown', this.keyHandler)
      this.keyHandler = null
    }
  }

  toggleMute() {
    if (!this.currentVideo) return
    
    this.isMuted = !this.isMuted
    this.currentVideo.muted = this.isMuted
    this.updateMuteButtons()
  }

  updateMuteButtons() {
    if (!this.muteControls) return
    
    const muteBtn = this.lightbox.querySelector('.pswp__button--mute')
    const unmuteBtn = this.lightbox.querySelector('.pswp__button--unmute')
    
    if (this.isMuted) {
      unmuteBtn.classList.add('active')
      muteBtn.classList.remove('active')
    } else {
      unmuteBtn.classList.remove('active')
      muteBtn.classList.add('active')
    }
  }

  disconnectedCallback() {
    if (this.lightbox) {
      this.closeLightbox()
    }
  }
}

customElements.define('product-tab-media', ProductTabMedia)
